import { z } from "zod";
import { checkGreekVATNumber } from "../vatnumbers";

export const greekVATNumber = z
  .string()
  .refine(checkGreekVATNumber, "Μή έγκυρος έγκυρος Α.Φ.Μ");
